// DEFINE THE VARIABLE THAT'LL HOLD A REFERENCE TO setTimeout() FUNCTION'S
var resizeListenerNewsItemsGeneral;

// SET 'true' TO ACTIVATE CONSOLE LOGS
var debugNewsItemsGeneral = false;



/* *** / WIN. LOAD \ *** */
$(window).bind("load", function() {

    // (KEEP) CHECKING IF OTHER JS IS LOADED
    var checkIfOtherIsLoaded = setInterval(function() {
        if(document.readyState === 'complete') {

            /* ************************************************************************ */
            /* *** / DETECT IF THE STATIC FILTER BUTTON IS IN THE VIEWPORT... \ *** */
            /* ************************************************************************ */

            function toggleFixedFilterBtn() {
                // DEFINE FILTER BUTTONS
                const staticFilterBtn = $(document).find('.js-btn-filter-static');
                const fixedFilterBtn = $(document).find('.js-btn-filter-fixed');

                // DEFINE ELEMENT HEIGHT
                const btnHeight = $(fixedFilterBtn).outerHeight();

                // ...HIDE STICKY FILTER BUTTON IF THE THE STATIC FILTER BUTTON IS IN THE VIEWPORT 
                if ( $(staticFilterBtn).isInViewport() ) {
                    if (debugNewsItemsGeneral){
                        console.log("Static filter button is visible in the viewport");
                    }

                    $(fixedFilterBtn).css("margin-bottom", -btnHeight).removeClass("slide-in");
                // ... SHOW STICKY FILTER BUTTON IF THE THE STATIC FILTER BUTTON IS NOT THE VIEWPORT 
                }else {
                    if (debugNewsItemsGeneral){
                        console.log("Static filter button is not visible in the viewport");
                    }

                    $(fixedFilterBtn).css("margin-bottom", 0).addClass("slide-in");
                }
            }

            // CALL 'toggleFixedFilterBtn' FUNCTION
            toggleFixedFilterBtn();

            /* ************************************************************************ */
            /* *** / END DETECT IF THE STATIC FILTER BUTTON IS IN THE VIEWPORT... \ *** */
            /* ************************************************************************ */
            


            /* ************************************************************************ */
            /* *** / HIGHLIGHT FIRST ACTIVE ITEM (MAIN CATEGORY) \ *** */
            /* ************************************************************************ */

            function highlightFirstActiveItem() {
                const catNavItems = $(".js-blog-category-menu .list-group-item");
                const path = window.location.pathname.toLowerCase();

                // CATEGORY NAV: FIND LINKS TO CURRENT PAGE AND HIGHLIGHT AS ACTIVE
                $(catNavItems).find("a[href*='" + location.pathname + "']").each( function() {
                    if ( $(this).attr("href") == "/blog" && path == "/blog") {
                        $(this).addClass("active");
                    }
                });    
                
                // REMOVE DUPLICATED BREADCRUMB ITEM
                $(document).find(".breadcrumb a[href*='" + location.pathname + "']").each( function() {            
                    if ( $(this).attr("href") == "/blog" && path == "/blog") {
                        $(this).parent(".breadcrumb-item").remove();
                    }
                });
            };

            highlightFirstActiveItem();

            /* ************************************************************************ */
            /* *** / END HIGHLIGHT FIRST ITEM (MAIN CATEGORY) \ *** */
            /* ************************************************************************ */


            /* ************************************************************************ */
            /* *** / CALL FUNCTIONS ON SCROLL \ *** */
            /* ************************************************************************ */

            $(window).on("scroll", function () {
                toggleFixedFilterBtn();
            });

            /* ************************************************************************ */
            /* *** / END CALL FUNCTIONS ON SCROLL \ *** */
            /* ************************************************************************ */



            /* ************************************************************************ */
            /* *** / RECALL FUNCTION(S) IF THE WINDOW RESIZES \ *** */
            /* ************************************************************************ */

            $(window).resize(function () {
                // EVERY TIME THE WINDOW RESIZE IS CALLED CANCEL THE setTimeout() FUNCTION
                clearTimeout(resizeListenerNewsItemsGeneral);

                // SET OUT FUNCTION TO RUN AFTER A SPECIFIED AMOUNT OF TIME 
                resizeListenerNewsItemsGeneral = setTimeout(function () {
                    
                    toggleFixedFilterBtn();

                    $(document).trigger('ot-resized--news-items-general');
                }, 500);
            });

            /* ************************************************************************ */
            /* *** / END RECALL FUNCTION(S) IF THE WINDOW RESIZES \ *** */
            /* ************************************************************************ */
            
            // CLEAR INTERVAL (STOP CHECKING)
            clearInterval(checkIfOtherIsLoaded);
        }else{
            return;
        }
    }, 100); // CHECK EVERY 100MS

});
/* *** / END WIN. LOAD \ *** */